import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { v4 } from 'uuid';
import { onActions } from '../../utils/helpers/redux.helper';
import {
  ActionsEnum,
  changeEmail,
  fetchAccountDetails,
} from './account-data.actions';
import { LocalizationService } from '../localization/localization.service';

@Injectable()
export class AccountDataDispatcher {
  constructor(
    private _store: Store<any>,
    private _actions: Actions,
    private _localizationService: LocalizationService
  ) {}

  changeEmail(emailAddress: string, locale?: string): Observable<any> {
    const dispatchId = v4();

    this._store.dispatch(
      changeEmail(
        dispatchId,
        emailAddress,
        locale || this._localizationService.getLocale()
      )
    );

    return onActions(
      this._actions,
      [ActionsEnum.CHANGE_EMAIL_SUCCESS, ActionsEnum.CHANGE_EMAIL_ERROR],
      dispatchId
    );
  }

  fetchUser(): Observable<void> {
    const dispatchId = v4();

    this._store.dispatch(fetchAccountDetails(dispatchId));

    return onActions(
      this._actions,
      [ActionsEnum.FETCH_ACCOUNT_DETAILS_SUCCESS],
      dispatchId
    );
  }
}
